module.exports = __webpack_public_path__ + "img/cover-6.c1b9544f.jpg";